import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { BehaviorSubject } from 'rxjs';

import { IconButtonDirective } from '../../../ui/button/icon-button/icon-button.directive';
import { FastTooltipDirective } from '../../directives/fast-tooltip.directive';

@Component({
  imports: [CommonModule, FastTooltipDirective, OverlayModule, MatIconModule, IconButtonDirective],
  selector: 'semeris-not-supported-browser-indicator',
  templateUrl: './not-supported-browser-indicator.component.html',
  styleUrls: ['./not-supported-browser-indicator.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotSupportedBrowserIndicatorComponent {
  public isOpen$ = new BehaviorSubject<boolean>(false);

  public browserInfo: string = navigator.userAgent;
  public intersectionObserverSupported = this.isIntersectionObserverSupported();
  public urlConstructorSupported = this.isUrlConstructorSupported();

  public toggle() {
    this.isOpen$.next(!this.isOpen$.value);
  }

  private isIntersectionObserverSupported(): boolean {
    return !!window && !!window.IntersectionObserver;
  }

  private isUrlConstructorSupported(): boolean {
    return !!window && !!window.URL;
  }
}
